/*This script combines polyfills.js and main.js into a single file*/

async function loadModules() {
  await import('./polyfills.js');
  await import('./main.js');
}

loadModules();
